import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { urlOrMe } from 'utils/converters';

import CarrierInfo from './CarrierInfo';
import Drivers from './Drivers';
import Vehicles from './Vehicles';
import RoutesTree from './RoutesTree';
import Uuid from './Uuid';
import Contracts from './Contracts';
import CarrierStatus from './CarrierStatus';

import style from './style.module.scss';
import { mapRoute } from 'reducers/routes';
import { DRIVER_STATES } from 'components/CarrierDetails/Constants';
import { CARRIER_STATES } from 'components/CarrierDetails/Constants';
import { driverUpdated } from 'redux/modules/carrier-section/effects';
import { updateDocuments as updateDocumentsAction } from 'actions/carriers';
import LogCarrierNotes from 'components/LogCarrierNotes';
import DocumentsList from 'components/DocumentsList';

class CarrierDetails extends Component {
  static propTypes = {
    carrier: PropTypes.object,
    vehicles: PropTypes.array,
    drivers: PropTypes.array,
    dedicatedContracts: PropTypes.array,
    onEditCarrier: PropTypes.func,
    onNewDriver: PropTypes.func,
    onNewVehicle: PropTypes.func,
    onEditDriver: PropTypes.func,
    onEditVehicle: PropTypes.func,
    updateCarrier: PropTypes.func,
    updateDriver: PropTypes.func,
    intl: PropTypes.any,
    onFilterCarrier: PropTypes.func,
    onFilterDriver: PropTypes.func,
    onNewContract: PropTypes.func,
    onEditContract: PropTypes.func,
    fetchDedicatedContracts: PropTypes.func,
    allRoutes: PropTypes.array,
    documents: PropTypes.array,
  };

  constructor() {
    super();
    this.onActiveClick = this.onActiveClick.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
  }

  componentDidMount() {
    const { fetchDedicatedContracts, carrier } = this.props;

    fetchDedicatedContracts({ carrier });
  }

  onActiveClick(driver) {
    const nextDriver = {
      ...driver,
      carrier: urlOrMe(driver.carrier),
      status: DRIVER_STATES.active,
    };
    this.props.updateDriver(nextDriver).then(() => this.props.driverUpdated(nextDriver.id));
  }

  async handleProfileChange(profile) {
    const { carrier, updateCarrier, updateDocuments } = this.props;
    await updateCarrier({
      id: carrier.id,
      profile,
    });
    await updateDocuments(carrier.id);
  }

  render() {
    const {
      carrier,
      vehicles,
      drivers,
      onEditCarrier,
      onNewDriver,
      onNewVehicle,
      onEditDriver,
      onEditVehicle,
      updateCarrier,
      intl,
      onFilterCarrier,
      onFilterDriver,
      onNewContract,
      onEditContract,
      dedicatedContracts,
      allRoutes,
      documents,
      isContractSectionDisabled,
      isDocumentSectionDisabled,
      isUuidSectionDisabled,
    } = this.props;

    const t = intl.messages.components.CarrierDetails;

    if (carrier && carrier.status === CARRIER_STATES.removed) {
      return (
        <article>
          <div className={style.mainTitleContainer}>
            <h1>{carrier.name}</h1>
            {carrier.status_log && carrier.status_log.length > 0 && (
              <LogCarrierNotes id={carrier.id} log={carrier.status_log} />
            )}
          </div>
          <p>{t.carrier_removed}</p>
        </article>
      );
    }

    return carrier ? (
      <article data-testid="carrier-details">
        <div className={style.mainTitleContainer}>
          <h1>{carrier.name}</h1>
          {carrier.status_log && carrier.status_log.length > 0 && (
            <LogCarrierNotes id={carrier.id} log={carrier.status_log} />
          )}
        </div>
        <CarrierStatus
          t={t}
          carrier={carrier}
          activateCarrier={() =>
            updateCarrier({
              id: carrier.id,
              is_active: true,
              status: CARRIER_STATES.active,
            })
          }
        />
        <CarrierInfo
          carrier={carrier}
          onEditCarrier={onEditCarrier}
          onFilterCarrier={onFilterCarrier}
        />
        <Drivers
          carrier={carrier}
          drivers={drivers}
          onNewDriver={onNewDriver}
          allowNew={!carrier.is_blocked}
          onEditDriver={onEditDriver}
          onActiveClick={this.onActiveClick}
          onFilterDriver={onFilterDriver}
        />
        <Vehicles
          carrier={carrier}
          vehicles={vehicles}
          onNewVehicle={onNewVehicle}
          allowNew={!carrier.is_blocked}
          onEditVehicle={onEditVehicle}
        />
        <RoutesTree
          routes={carrier.routes.map(mapRoute(true))}
          allRoutes={allRoutes}
          onChange={(routes) =>
            updateCarrier({
              id: carrier.id,
              routes,
            })
          }
        />

        {!isContractSectionDisabled && (
          <Contracts
            contracts={dedicatedContracts}
            onNewContract={onNewContract}
            onEditContract={onEditContract}
            allowNew={!carrier.is_blocked}
          />
        )}

        {!isDocumentSectionDisabled && (
          <DocumentsList
            serverDocuments={documents}
            carrierProfiles={carrier.profile}
            showProfileSelector
            onChangeProfile={this.handleProfileChange}
            landingLink={carrier.landing_link}
            entity={{ entity_id: carrier.id, entity_type: 'carrier', entity_uuid: carrier.uuid }}
            refreshDocuments={async () => await this.props.updateDocuments(carrier.id)}
          />
        )}

        {!isUuidSectionDisabled && <Uuid uuid={carrier.uuid} />}
      </article>
    ) : (
      <article>{t.no_carrier_found}</article>
    );
  }
}

export default connect(null, { driverUpdated, updateDocuments: updateDocumentsAction })(
  injectIntl(CarrierDetails)
);
